
// Accordion

(function () {

	var accordion = {

		show: function (e) {

			var target = e.target;
			var parent = target.parentNode;
			var header = 'accordion__header';
			
			if ( target.classList.contains( header ) || parent.classList.contains( header ) ) {

				var el = target.closest( '.accordion' );

				if (el) el.classList.toggle( 'accordion_active' );

			}

		},

		init: function () {

			this.els = document.querySelectorAll( '.accordion' );

			if ( !this.els ) return

			document.addEventListener( 'click', this.show.bind( this ) );

			return this

		}

	}

	return accordion.init();

})();
